import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { nanoid } from "nanoid"
import { useState } from "react"

const ExpandbleTabs = ({
  tabs = [],
  panels = {},
  selected,
  setSelected,
}: $TSMigrationFixMe) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <div className='tw-flex-row tw-min-w-fit tw-bg-simple-10 tw-flex tw-w-full tw-h-full'>
      <div className='tw-flex-col tw-border-solid tw-border-r tw-border-l tw-border-neutral-25'>
        <div className='tw-mx-4 tw-mt-2 tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center'>
          <FontAwesomeIcon
            className='tw-h-5 tw-cursor-pointer'
            icon={["fal", expanded ? "close" : "bars"]}
            onClick={() => setExpanded(!expanded)}
          />
        </div>
        {/* @ts-expect-error TS(7006): Parameter 'section' implicitly has an 'any' type. */}
        {tabs?.map((section) => (
          <div
            key={nanoid()}
            className='tw-border-solid tw-border-b tw-border-neutral-25'
          >
            {section.items?.map((tab: $TSMigrationFixMe) => (
              <div
                key={tab.key}
                className={`tw-flex tw-mx-4 tw-my-2 tw-cursor-pointer tw-flex-row tw-items-center tw-min-w-max tw-text-primary ${
                  selected === tab.key
                    ? "tw-rounded tw-text-simple-10 tw-bg-alternative2"
                    : ""
                }`}
                onClick={() => setSelected(tab.key)}
              >
                <div className='tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center'>
                  <FontAwesomeIcon
                    className='tw-h-5'
                    icon={["fal", tab.icon]}
                  />
                </div>

                {expanded && (
                  <div className='tw-px-2 tw-text-start'>{tab.label}</div>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className='tw-w-full tw-h-full'>{panels[selected]}</div>
    </div>
  )
}

export default ExpandbleTabs
